import React from 'react';
import classes from './LockScreen.module.css';
import Button from 'Components/UI_Library/FormElements/Button';

import ScreenPreview from './CardsPreview.png';
import Success from 'Components/UI_Library/Icons/NewIconSet/Success.png';
import Config from 'Config';

const infoLink = 'platform/spend-management';

const CardsLockScreen = () => {
    return (
        <div className={classes.lockScreen}>
            <div className={classes.copy}>
                <h4>Cards</h4>
                <h2>Corporate cards that help you spend smarter</h2>
                <p>
                    Paytron cards get you up and running in seconds and make it easy to maintain control and visibility
                    over your spend.
                </p>
                <div className={classes.listItem}>
                    <img src={Success} />
                    <div>Easily issue employee and subscription cards, and add to Apple or Android Wallet.</div>
                </div>
                <div className={classes.listItem}>
                    <img src={Success} />
                    <div>
                        Spend like a local in foreign currency straight from your balances, or convert at bank beating
                        rates.
                    </div>
                </div>
                <div className={classes.listItem} style={{ marginBottom: '2rem' }}>
                    <img src={Success} />
                    <div>Enjoy built-in spend controls and receipt capture for control and efficiency.</div>
                </div>
                <div className={classes.controls}>
                    <Button
                        type="white"
                        text="Learn more"
                        onClick={() => {
                            window.open(`${Config.paytronHomePage}/${infoLink}`, '_blank');
                        }}
                        style={{ marginRight: '1rem' }}
                    />
                </div>
            </div>
            <div className={classes.preview}>
                <img src={ScreenPreview} />
            </div>
        </div>
    );
};

export default CardsLockScreen;
